<template>
	<div class="login">
<header>
	
	<div>
	
		<div>
		
			<a href="#" title="Cargo - by GEA Logistics">Cargo - by GEA Logistics</a>
		
		</div>
	
	</div>
	
</header>
<article>
		<form v-on:submit.prevent="" id="msform" name="msform" action="index2.html">
			<!-- fieldsets -->
			<fieldset>
				<div class="modulo-opciones">
					<h2 class="fs-title">
						ACCESO PARA CLIENTES
					</h2>
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label :for="`cuit`">Ingrese CUIT</label>
								<input 
									class="form-control cuit"
									v-mask="'##-########-#'"
									v-model="cuit"
									id="cuit" 
									name="cuit" 
									placeholder="Ingrese CUIT" 
									type="text"
								/>
								<div class="help-block with-errors"></div>
							</div>
                  		</div>
					</div> 
				</div>
				<input class="submit action-button" name="submit" type="submit" value="Ingresar" @click="this.login">
			</fieldset>
			
		</form>
		</article>

<footer>

	&copy; Copyright 2019 GEA Logistics - Todos los Derechos Reservados.

</footer> 
	
	</div>
</template>

<script>
import {mask} from 'vue-the-mask'

export default {
  directives: {mask},
  data () {
    return {
	  cuit: null,
    }
  },
  methods: {
    login () {
      this.$router.push({ path: '/nueva-oc', params: {cuit: this.cuit }})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
@import '../assets/css/estilo-form.css';

.form-control, .vuetagger-input {
  font-size: 16px;
  border: none;
  border-bottom: 1px solid #cccccc;
  border-radius:0!important;
  -webkit-box-shadow: none!important;
  box-shadow:none!important;
  padding:7px 5px 7px 27px!important;
}
.cuit {
    background: url(../assets/img/icon/id-card.svg) no-repeat center left !important;
    background-size: 18px 18px !important;
    background-position: 0px !important;
}
.vuetagger-input {
    background: url(../assets/img/icon/email.svg) no-repeat center left !important;
    background-size: 18px 18px !important;
    background-position: 0px !important;
}
.form-group label {
  float: left;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight:300;
  text-transform:uppercase;
  margin-bottom: 10px;
}
.login header div:nth-Child(1) {
	float: left;
	width: 100%;
}
.login header div:nth-Child(1) h1 {
	background: url(../assets/img/logo-big.svg) no-repeat top center;
	width: 100%;
	height: 85px;
	margin: 140px 0px 80px 0px;
	margin: 100px 0px 60px 0px;
}
.login #msform {
	max-width: 555px;
}
.login .fs-title {
	font-size: 19px;
	letter-spacing: 0.3em;
	font-weight: 400;
	font-family: 'Roboto', sans-serif;
	margin: 20px 0px 20px 0px;
}
.login .modulo-opciones {
	max-width: 360px;
	border-bottom: 0px solid #d0d0d0;
}
.login #msform .action-button {
    width: 100%;
    background: #008cba;
    font-weight: 700;
    color: white;
    border: 0 none;
    border-radius: 5px;
    cursor: pointer;
    padding: 13px 0px;
    font-size: 18px;
    font-family: 'Montserrat', sans-serif;
    text-transform: uppercase;
    margin: 15px 0px 20px 0px;
}
.login footer {
	margin-top: 150px;
}

.login footer {
	height: auto;
}

.login footer div:nth-Child(2) {
	float: left;
	width: calc(100% - 320px);
}

.login footer div:nth-Child(2) h1 {
	float: left;
	width: 100%;
	text-align: center;
	margin-top: 50px;
}

.login footer div:nth-Child(3) {
	float: left;
	width: 159px;
	margin-top: 48px;
}

.login footer div:nth-Child(3) a {
	text-align: right;
	font-size: 14px;
	color: #acacac;
	font-weight: 400;
}

@media (max-width: 860px) {
	.login #msform {
		max-width: 100%;
	}
	.login footer div:nth-Child(1) {
		width: 100%;
	}
	.login footer div:nth-Child(1) h1 {
		width: 100%;
		background-position: top center;
	}
	.login footer div:nth-Child(2) {
		width: 100%;
	}
	.login footer div:nth-Child(2) h1 {
		margin-top: 0px;
	}
	.login footer div:nth-Child(3) {
		float: left;
		text-align: center;
		width: 100%;
		margin-top: 0px;
		margin-bottom: 25px;
	}
	.login #msform .action-button {
		width: 100%;
		max-width: 360px;
		margin: 0px 0px 50px 0px;
	}
}
a *
{
  margin: 0;
  padding: 0;
}

.login
{
  	height: 100%;
  	background-image: url(../assets/img/bg2.jpg);
  	background-position: top center;
  	background-size: cover;
	font-family: 'Roboto', sans-serif;
  	margin: 0px auto;
  	overflow-x: hidden !important;
}

 
/* HEADER */

.login header
{
  width: 100%;
  height: 42px;
  margin: 0px auto;
  max-width: 1070px;
}



.login header div div a
{
  float: left;
  margin:45px 0px 45px 0px;
  width: 168px;
  height: 42px;
  background: url(../assets/img/logo-big.svg) no-repeat top left;
  cursor: pointer;
  text-indent: -99999px;
}

/* CONTENIDO */

.login article
{
  width: 100%;
  margin: 45px 0px 45px 0px;
  text-align: center;
}

#msform
{
  width: 100%;
  margin: 0px auto;
}

#msform fieldset
{
  background: white;
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px 1px rgba(255, 255, 255, 0.1);
  padding: 45px 75px;
  box-sizing: border-box;
  width: calc(100% - 0px);
  max-width: 450px;
  margin: 0px auto;
  position: relative;
}

#msform h2
{
  color: #5b5b5f;
  font-size: 15px;
  font-weight: 300;
  font-style: italic;
  margin: 0px 0px 15px 0px;
}

#msform h1
{
  color: #008cba;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0px 0px 40px 0px;
}

#msform input[type="text"]
{
  padding: 17px 25px;
  /* border: 2px solid; */
  border-radius: 15px;
  margin: 0px 0px 20px 0px;
  width: calc(100% - 4px);
  box-sizing: border-box;
  color: #9c9aa0;
  font-size: 18px;
  font-weight: 400;
}

#msform input[type="submit"]
{
  background: #008cba;
  border: 2px solid;
  border-radius: 15px;
  width: 100%;
  box-sizing: border-box;
  color: #fff;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 700;
  cursor: pointer;
}

#msform input[type="submit"]:hover
{
  /* color: #008cba;
  background: #fff; */
}
 
/* FOOTER */

.login footer
{
  margin: 0px auto;
  width: 100%;
  max-width: 500px;
  color: #2f80b0;
  font-size: 14px;
  text-align: center;
}

/* RESPONSIVE */

@media (max-width: 1070px)
{
	
  .login header div div a
  {
	margin: 0px auto;
	margin-top:45px;
	margin-bottom:45px;
    width: 100%;
    background: url(../assets/img/logo-big.svg) no-repeat top center;
  }

  #msform fieldset
  {
    padding: 45px 45px;
  }
}
 
</style>



// WEBPACK FOOTER //
// src/components/Login.vue